module.exports = __webpack_public_path__ + "img/dig-planet.1c345fe9.svg";